// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "font-kVVagm": "font-x1iacy",
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "borderColor-kVAM5u": "borderColor-x9r1u3d",
    "borderRadius-kaIpWk": "borderRadius-xhpnuu7",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "minWidth-k7Eaqz": "minWidth-x11inojt",
    $$css: "wino-gc:src/resources/feedback-indicators/CountBadge.res.js:8"
  },
  size_small: {
    "fontSize-kGuDYH": "fontSize-x1k6wstc",
    "padding-kmVPX3": "padding-xxzb6uj",
    $$css: "wino-gc:src/resources/feedback-indicators/CountBadge.res.js:18"
  },
  size_medium: {
    "fontSize-kGuDYH": "fontSize-xfifm61",
    "padding-kmVPX3": "padding-x1jzfyzl",
    $$css: "wino-gc:src/resources/feedback-indicators/CountBadge.res.js:22"
  },
  size_large: {
    "fontSize-kGuDYH": "fontSize-xif65rj",
    "padding-kmVPX3": "padding-x1whlmpv",
    $$css: "wino-gc:src/resources/feedback-indicators/CountBadge.res.js:26"
  }
};
function colorFromStyleOptions(variation, tone, accent) {
  if (variation === "solid") {
    if (tone === "brand") {
      return "#a01e72";
    } else {
      return "#25243a";
    }
  } else if (variation === "ghost") {
    if (tone === "brand") {
      if (accent) {
        return "#fbe8f8";
      } else {
        return "#fdf2fb";
      }
    } else if (accent) {
      return "#e7e7ee";
    } else {
      return "#f3f3f7";
    }
  } else if (tone === "brand") {
    return "white";
  } else {
    return "#25243A";
  }
}
function styleFromSize(size) {
  if (size === "medium") {
    return styles.size_medium;
  } else if (size === "small") {
    return styles.size_small;
  } else {
    return styles.size_large;
  }
}
function styleFromVariation(variation, tone, accent) {
  if (tone === "neutral") {
    return {
      color: "#25243A",
      backgroundColor: "#F3F3F7",
      borderColor: "#D7D7E0"
    };
  }
  let color = colorFromStyleOptions(variation, tone, accent);
  if (variation === "solid") {
    return {
      color: "white",
      backgroundColor: color
    };
  } else if (variation === "ghost") {
    return {
      color: color,
      backgroundColor: color
    };
  } else {
    return {
      color: color,
      backgroundColor: "#E7E7EE",
      borderColor: "#A2A1B0"
    };
  }
}
function styleProps(size, variation, tone, accent) {
  return Stylex.props(styles.root, styleFromSize(size), styleFromVariation(variation, tone, accent), styles.border);
}
function CountBadge(props) {
  let __accent = props.accent;
  let __tone = props.tone;
  let __variation = props.variation;
  let __size = props.size;
  let size = __size !== undefined ? __size : "medium";
  let variation = __variation !== undefined ? __variation : "solid";
  let tone = __tone !== undefined ? __tone : "brand";
  let accent = __accent !== undefined ? __accent : false;
  let match = styleProps(size, variation, tone, accent);
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let make = React.memo(CountBadge);
export { make };
/* styles Not a pure module */